import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  IconButton,
  Grid,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { CustomTitle, CustomLabel, CustomValue } from "./CustomTypography";

const CustomDialog = ({ open, onClose, title, content }) => {
  return (
    <Dialog open={open} onClose={onClose} maxWidth="md">
      <DialogTitle style={{ width: "300px" }}>
        <CustomTitle>{title}</CustomTitle>
        <IconButton
          aria-label="close"
          onClick={onClose}
          sx={{ position: "absolute", right: 8, top: 8 }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent>
        {content.map(({ label, value }, index) => (
          <Grid key={index} container spacing={1}>
            <Grid item xs={6}>
              <CustomLabel>{label}</CustomLabel>
            </Grid>
            <Grid item xs={1}>
              <CustomLabel>:</CustomLabel>
            </Grid>
            <Grid item xs={5}>
              <CustomValue>{value}</CustomValue>
            </Grid>
          </Grid>
        ))}
      </DialogContent>
    </Dialog>
  );
};

export default CustomDialog;
